export const green = "#1cb2a8";
export const pink = "#f7657f";
export const darkBlue = "#253846";
export const lightBlue = "#61c3e6";
export const yellow = "#fece3f";
export const orange = "#fc511e";